function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4104 16 16 12.4104 16 8C16 3.58965 12.418 0 8.00767 0C7.4861 0 7.17929 0.306807 7.17929 0.805369V3.53595C7.17929 3.96548 7.47843 4.2953 7.90796 4.2953C8.33749 4.2953 8.63663 3.96548 8.63663 3.53595V1.75647C11.8044 2.07862 14.2359 4.74784 14.2359 8C14.2359 11.4516 11.4669 14.2435 8 14.2435C4.53308 14.2435 1.7488 11.4516 1.75647 8C1.76414 6.54267 2.27037 5.18504 3.11409 4.12656C3.44391 3.66635 3.50527 3.21381 3.12943 2.83797C2.7536 2.47747 2.15532 2.51582 1.77181 3.02972C0.674976 4.39501 0 6.12848 0 8C0 12.4104 3.58965 16 8 16ZM9.2349 9.21956C9.88687 8.54458 9.75647 7.60115 8.98178 7.08725L5.18504 4.5024C4.67881 4.16491 4.19559 4.64813 4.53308 5.15436L7.11026 8.9511C7.63183 9.72579 8.56759 9.87152 9.2349 9.21956Z",
  fill: "#FFAE00"
});

function SvgWeeks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeks);
export default __webpack_public_path__ + "static/media/weeks.b4a7b54e.svg";
export { ForwardRef as ReactComponent };